import React from 'react';
import ApparelTees from '../ApparelTees';

const Hoodies = () => {
  return (
    <>
      <ApparelTees />
    </>
  );
};
export default Hoodies;
